export default __webpack_public_path__ + "static/media/3.e68c80d0.jpg";